import { getPlatform } from './url';
type ModeType = 'development' | 'dev' | 'test' | 'uat' | 'prod';
export const getEnv = () => import.meta.env as ImportMetaEnv;

export const getEnvMode = () => {
  const mode = import.meta.env?.MODE as ModeType;
  const devMode = import.meta.env?.VITE_DEV_MODE as ModeType;
  if (mode === 'development') {
    return devMode || mode;
  }
  return mode;
};

export const getApiBaseUrl: () => string = () =>
  import.meta.env?.VITE_GLOB_API_URL;

export const getApiPrefix: () => string = () =>
  import.meta.env?.VITE_GLOB_API_URL_PREFIX;

export const getRedirectUrl: () => string = () => {
  const platform = getPlatform();
  switch (platform) {
    case 'admin':
      return import.meta.env?.VITE_GLOB_ADMIN_REDIRECT_URL;
    case 'quick':
      return import.meta.env?.VITE_GLOB_QUICK_REDIRECT_URL;
    case 'word':
      return import.meta.env?.VITE_GLOB_WORD_REDIRECT_URL;
    default:
      return import.meta.env?.VITE_GLOB_APLUS_REDIRECT_URL;
  }
};

// export const env = import.meta.env as unknown as ImportMetaEnv;
